export const navLink = [
	{
		href: 'https://www.linkedin.com/in/smaro-nitr',
		target: '_blank',
		icon: 'fab fa-linkedin-in',
		title: 'smaro-nitr',
	},
	{
		href: 'mailto:smaro.nitr@gmail.com',
		target: '_self',
		icon: 'fas fa-at',
		title: 'smaro.nitr@gmail.com',
	},
	{
		href: 'tel:+91-7750811003',
		target: '_self',
		icon: 'fas fa-phone-alt',
		title: '+91-7750811003',
	},
	{
		href:
			'https://www.google.co.in/maps/place/Pune,+Maharashtra/@18.5245649,73.7228805,11z/data=!3m1!4b1!4m5!3m4!1s0x3bc2bf2e67461101:0x828d43bf9d9ee343!8m2!3d18.5206322!4d73.8569641',
		target: '_blank',
		icon: 'fas fa-map-marker-alt',
		title: 'google map',
	},
]
